// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"ca61c607","189":"e7c05cf9","316":"62589bc1","351":"acb77372","540":"a40970c3","553":"8aaa1c47","623":"9582d05a","767":"a3c57071","788":"59c10d07","803":"810c26f0","813":"6cd22b82","917":"cc621a2d","984":"f36ecaa2"}[chunkId] + ".chunk.js";
};